export default __webpack_public_path__ + "assets/images/c24e1db170a0747ab9d93140966544be.svg";